export enum VehicleCountryCode {
  NO = 'N',
  DK = 'DK',
  FI = 'FIN',
  SE = 'S',
  AL = 'AL',
  AD = 'AND',
  BE = 'B',
  BA = 'BIH',
  BG = 'BG',
  CY = 'CY',
  EE = 'EST',
  FR = 'F',
  GR = 'GR',
  IE = 'IRL',
  IS = 'IS',
  IT = 'I',
  HR = 'HR',
  LV = 'LV',
  LI = 'FL',
  LT = 'LT',
  LU = 'L',
  MT = 'M',
  MD = 'MD',
  MC = 'MC',
  ME = 'MNE',
  NL = 'NL',
  PL = 'PL',
  PT = 'P',
  RO = 'RO',
  RU = 'RUS',
  SM = 'RSM',
  CH = 'CH',
  RS = 'SRB',
  SK = 'SK',
  SI = 'SLO',
  ES = 'E',
  GB = 'UK',
  CZ = 'CZ',
  TR = 'TR',
  DE = 'D',
  UA = 'UA',
  HU = 'H',
  VA = 'V',
  BY = 'BY',
  AT = 'A',
  GE = 'GE',
}
